import React from 'react';
import { Row, Col } from 'antd';
import Fieldset from '../Fieldset/Fieldset';
import HiddenField from '../HiddenField/HiddenField';
import { formConfig } from '../../../../config';
import SelectMasterField from '../SelectMasterField/SelectMasterField';
import SelectExecuterField from '../SelectExecuterField/SelectExecuterField';

const { fieldNames } = formConfig;

const AddressFieldset = ({ form, request, mode }) => {
  return (
    <Fieldset legend="Смена мастера и исполнителя">
      <HiddenField
        form={form}
        name={fieldNames.address}
        initialValue={request.addressId}
      />
      <HiddenField
        form={form}
        name={fieldNames.service}
        initialValue={request.serviceId}
      />
      <Row gutter={12}>
        <Col span={12}>
          <SelectMasterField
            form={form}
            request={request}
            mode={mode}
          />
        </Col>
        <Col span={12}>
          <SelectExecuterField
            form={form}
            request={request}
            mode={mode}
          />
        </Col>
      </Row>
    </Fieldset>
  );
};

export default AddressFieldset;
